import React from 'react';
import { UniverseModuleType } from 'src/domains/common/universes.type';
import { features } from './energy.features';
import { themeColors } from './energy.config';
import { EnergyLogotype } from './energy.logotype';
import { EnergyLogo } from 'src/layouts/LoginPage/logos/EnergyLogo';
import EnergyLoginImage from 'src/layouts/LoginPage/loginBgImages/EnergyLoginImage.jpg';
import { EnergyBrandIconWrapper } from './energy.style';
import { LoginImageWrapper } from 'src/layouts/LoginPage/LoginImage.style';

export const universeModule: UniverseModuleType = {
    themeColors,
    features,
    title: 'NRG Backoffice',
    urls: {
        website: 'https://nrg.bet/',
        backoffice: 'https://backoffice.nrg.bet/',
    },
    BrandIcon: () => <EnergyBrandIconWrapper />,
    Logotype: () => <EnergyLogotype />,
    LogotypeLoginPage: () => <EnergyLogo />,
    compliancePopupLogo: null,
    loginImageContainer: () => <LoginImageWrapper imgSrc={EnergyLoginImage} />,
};
